import React, { useEffect } from 'react'
import { Form } from 'antd'
import PropTypes from 'prop-types'
import NameInput from 'view/component/form-items/name-input'
import SiteSelect from 'view/component/form-items/site-select'

const TagForm = ({ tag, tagUuid, form, site }) => {
  useEffect(() => {
    form.setFieldsValue(tag)
  }, [tag])

  return (
    <Form
      form={form}
      layout='vertical'
    >
      <NameInput />
      {site &&
        <>
          <SiteSelect
            disabled={true}
            sites={site}
          />
        </>}
    </Form>
  )
}

TagForm.propTypes = {
  form: PropTypes.object,
  site: PropTypes.array,
  tag: PropTypes.object,
  tagUuid: PropTypes.string
}

export default TagForm
